<div class="relative w-full pt-[100%]">
  <div class="absolute inset-0 bg-[#efefef] px-3">
    @if (imageSrc(); as imageSrc) {
      <app-image-thumbnail size="full">
        <img
          class="object-contain"
          [alt]="imageAlt()"
          [fill]="true"
          [ngSrc]="imageSrc!" />
      </app-image-thumbnail>
    }
  </div>

  <div class="absolute top-2 right-2">
    <app-public-box-status-label [availability]="availability()" />
  </div>
</div>
